import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    onlinePaymentReceived: false
};
export const onlinePaymentSlice = createSlice({
    name: "paymentMasterId",
    initialState,
    reducers: {
        setOnlinePaymentReceived: (state, action) => {
            state.onlinePaymentReceived = action?.payload;
        },
    },
});

export const { setOnlinePaymentReceived } = onlinePaymentSlice.actions;
export default onlinePaymentSlice.reducer;
